import { BasicPage } from "../theme/Component/BasicPage"
import { BasicButton } from '../theme/Component/BasicButton';
import { BasicTable, MASK_NUMBER, MASK_MONEY, MASK_DATE, MASK_MONEY_ROUND } from '../theme/Component/BasicTable';
import { Singleton } from '../../core/services/Singleton';
import { ContractService } from '../../core/services/ContractService';
import { useState, useEffect } from 'react';
import { ModalConfirm } from '../theme/Component/ModalConfirm';
import { Modal } from '../theme/Component/Modal';
import { AdquisitionItemCatalog } from "./AdquisitionItemCatalog";
import { AdquisitionPeople } from "./AdquisitionPeople";
import { Alert } from "../theme/Component/Alert";
import { AdquisitionStates } from "./AdquisitionStates";
import { AdquisitionPlanFunctionalID } from "./AdquisitionPlanFunctionalID";
import { AdquisitionHistory } from "./AdquisitionHistory";
import { AdquisitionPhase } from "./AdquisitionPhase";
import { PlanDropDown } from "./PlanDropDown";
import { ListMenu } from "../theme/Component/ListMenu";
import { useForm } from 'react-hook-form';
import { Modalcompras } from "../theme/Component/Modalcompras";
import { useDashboardStore } from "../pages/hooks/useDashboardStore";
import { BasicSwitch } from "../theme/Component/BasicSwitch";
import { toast } from "react-toastify";
import { ITEM_ADMIN } from "../Constants";
import { InputMoney } from "../theme/Input/InputMoney";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _ImpAdquisition } from "../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../core/services/dataBean/EntityCatalog";
import { FileInput } from "../theme/Component/FileInput";



export const AdquisitionPlanCatalog = () => {

    const single = Singleton.getInstance()
    const imp = useDataBean(_ImpAdquisition);
    const { setLoading } = useDashboardStore();
    const service = new ContractService();
    const [lista, setLista] = useState([]);
    const [listaType, setListaType] = useState([]);
    const [permisos, setPermisos] = useState([]);
    const [migrar, setMigrar] = useState<boolean>(false);
    const [idPlan, setIDPlan] = useState<number>(0);
    const [indexTap, setIndexTap] = useState(0);
    const [fromYear, setFromYear] = useState(0);
    const [uptoYear, setUptoYear] = useState(0);
    const [vista, setvista] = useState(0);
    const { register, formState: { errors }, handleSubmit } = useForm();
    const [bean, setBean] = useState<any>({});
    const [modal, setModal] = useState<any>({ name: 'Plan', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalnecesidad, setModalnecesidad] = useState<any>({ name: 'Plan', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalrubros, setModalrubros] = useState<any>({ name: 'Plan', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal1, setModal1] = useState<any>({ name: 'Configuración Plan', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const idBean = 'IDAdquisitionPlan';

    const head = [
        { title: 'ID', property: idBean, mask: MASK_NUMBER, visible: false },
        { title: 'Año', property: 'Year', mask: MASK_NUMBER },
        // { title: 'Tipo de Plan', property: 'TypeName' },
        { title: 'Descripción', property: 'Description' },
        { title: 'Valor total', property: 'TotalValue', mask: MASK_MONEY_ROUND },
        { title: 'Fecha Creado', property: 'Since', mask: MASK_DATE },
        { title: 'Etapa', property: 'PhaseStateName' },
        // { title: 'Estado', property: 'Estados' },
    ]
    // Se realiza la impelmentacion de la historia de usuario HU04 componente 67

    useEffect(() => {
        // getLista();
        let date = new Date();
        setFromYear(single.getCurrenYear());
        setUptoYear(single.getCurrenYear() + 1);
        // getApiPermissionsByRole();
        getAdquisitionPlanTypeConstants();
    }, [])
    useEffect(() => {

        if (indexTap === 0) {
            getLista();
        }

    }, [indexTap])

    //cambio para la capacitacion
    const setRowBean = (bean: any) => {
        setBean(bean);
        validarEdit();
    }

    const renderEstados = (item: any) => {

        let render = '';
        if (item.DataBeanProperties.PhaseState === 0) {
            render = item.DataBeanProperties.PlanningStateName;
        }
        else if (item.DataBeanProperties.PhaseState === 1) {
            render = item.DataBeanProperties.StructuringStateName;
        }
        else if (item.DataBeanProperties.PhaseState === 2) {
            render = item.DataBeanProperties.HiringStateName;
        }
        return render;
    }

    const getAdquisitionPlanTypeConstants = () => {
        service.getAdquisitionPlanTypeConstants(null).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    setListaType(resp.DataBeanProperties.ObjectValue);
                }
            }
        );
    }


    const getLista = () => {

        setLoading(true);
        service.getAdquisitionPlanCatalog(fromYear, uptoYear, null, null, null).subscribe(
            (resp: any) => {


                if (resp.DataBeanProperties.ObjectValue.DataBeanProperties.List) {
                    let ll = resp.DataBeanProperties.ObjectValue.DataBeanProperties.List;
                    ll.forEach((element: any) => {
                        element.DataBeanProperties.Estados = renderEstados(element);
                    });
                    setLista(ll.reverse());
                } else {
                    setLista([]);
                }

                setLoading(false);
            }
        );
    }


    const agregarItem = () => {
        let date = new Date();
        let b = {
            Year: date.getFullYear(),
            Description: '',
            TotalValue: 0,
            IDBudgetType: 0
        }

        setBean(b);
        setModal({ ...modal, ['view']: true });

    }
    const editarItem = () => {

        setModal({ ...modal, ['view']: true });

    }
    const eliminarItem = () => {

        setLoading(true);
        service.deleteAdquisitionPlan(bean[idBean]).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp) {
                    getLista();
                }
                single.delete(bean[idBean], bean);
            }
        );
        setModalConfirm({ ...modalConfirm, ['view']: false });

    }
    const updateItem = () => {

        setModal({ ...modal, ['view']: false });

        if (!migrar || bean.IDAdquisitionPlan > 0) {
            setLoading(true);
            service.updateAdquisitionPlan(bean).subscribe(
                (resp: any) => {

                    if (resp.DataBeanProperties.ObjectValue) {
                        getLista();
                    }
                    if (bean[idBean]) {

                        single.update(bean);

                    }
                    else {
                        single.create(bean);
                    }
                    setLoading(false);
                });

        }
        else {
            setLoading(true);
            service.createPlanByOtherIDPlan(idPlan, single.getAccountID(), bean).subscribe(
                (resp: any) => {

                    if (resp.DataBeanProperties.ErrorMessage) {
                        getLista();
                        toast.error(resp.DataBeanProperties.ErrorMessage);
                    }
                    else if (resp.DataBeanProperties.ObjectValue) {
                        getLista();
                        toast.success("Se ha creado el plan exitosamente");
                    }
                    if (bean[idBean]) {

                        single.update(bean);

                    }
                    else {
                        single.create(bean);
                    }
                    setLoading(false);
                });
        }



    }
    const updateItemModal = () => {

        setModal1({ ...modal1, "view": false });
        getLista();

    }

    let validarEdit = () => {
        let a = false;
        if (single.canEdit() && bean.PhaseState == 2) {
            a = true;
        } else {
            a = false;
        }
        return a;
    }

    const buttons = () => {
        return (
            <div className="row">
                <div className="col m-2">
                    {bean[idBean] &&
                        <PlanDropDown bean={bean} updateEvent={getLista} permisos={permisos}></PlanDropDown>
                    }
                </div>
            </div>
        )
    }

    const iconButtons = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: (single.canEdit() && (bean.PhaseState == 0)), evento: editarItem },
            {
                titulo: 'Ver Ítems', icono: 'ri-file-list-line', visible: true, evento: () => {
                    setModal1({ ...modal1, "view": true, "name": bean.Description, "btnSubmit": false });
                    setvista(6);
                }
            },
            {
                titulo: 'Ver Areas', icono: 'ri-git-merge-line', visible: true, evento: () => {
                    setModal1({ ...modal1, "view": true, "name": "Agregar Áreas/Dependencias", "btnSubmit": false });
                    setvista(3);
                }
            },
            { titulo: 'Eliminar', icono: 'ri-eraser-line', visible: (single.canEdit() && (bean.PhaseState == 0)), evento: () => { setModalConfirm({ ...modalConfirm, "view": true }) } },
            { titulo: 'Importar Necesidades', icono: 'ri-upload-fill', visible: single.canDelete(), evento: () => { setModalnecesidad({ ...modalnecesidad, "view": true }) } },
            { titulo: 'Importar Rubros', icono: 'ri-upload-2-line', visible: single.canDelete(), evento: () => { setModalrubros({ ...modalrubros, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const importAdquisitionItem = () => {
        //console.log(entailment.bean);
        imp.instance.importAdquisitionItem(_single.getAccountID(), bean.IDAdquisitionPlan, imp.bean.Media, imp.bean.MediaContext).then(
            (resp: any) => {
                console.log(resp)

                setModalnecesidad({ ...modalnecesidad, "view": false });
                toast.success(resp.OK);
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const importAdquisitionItemBudgetID = () => {
        //console.log(entailment.bean);
        imp.instance.importAdquisitionItemBudgetID(_single.getAccountID(), bean.IDAdquisitionPlan, imp.bean.Media, imp.bean.MediaContext).then(
            (resp: any) => {
                console.log(resp)
                setModalrubros({ ...modalrubros, "view": false });
                toast.success(resp.OK);
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <>
            <BasicPage titulo="Plan de Compras (PAA)">

                {indexTap === 0 &&
                    <>
                        <div className="row">
                            <div className="col-md-2">
                                <label>Año inicial</label>
                                <input type="number" className="form-control" value={fromYear} onChange={(e) => { setFromYear(parseInt(e.target.value)) }} />
                            </div>
                            <div className="col-md-2">
                                <label>Año Final</label>
                                <input type="number" className="form-control" value={uptoYear} onChange={(e) => { setUptoYear(parseInt(e.target.value)) }} />
                            </div>
                            <div className="col-md-2 mt-4">
                                <BasicButton value="Buscar" icon="ri-search-line" eventClick={getLista} />
                            </div>
                            <div className="col-md-12 p-2">
                                <BasicTable headButtons={buttons()} iconButtons={iconButtons} listButtons={listaBotones()} head={head} body={lista} rowSet={setRowBean}></BasicTable>
                            </div>
                        </div>
                    </>
                }

                {indexTap === 1 &&

                    <>
                        <AdquisitionItemCatalog _phaseState={bean.PhaseState} idAdquisitionPlan={bean[idBean]} />
                    </>
                }

            </BasicPage>

            <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                {bean.Name}
            </ModalConfirm>
            <Modal modal={modalnecesidad} updateModal={setModalnecesidad} eventModal={importAdquisitionItem}>
                <div className="row">
                    <div className="col-md-12">
                        <FileInput
                            Media={imp.bean.Media}
                            MediaContext={imp.bean.MediaContext}
                            directory='temp'
                            label='Archivo'
                            docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                            onCreate={(Filemap: any) => { imp.setBean({ ...imp.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-12 mt4">
                        <a href="assets/extra/Necesidad.xlsx" className="link" target="_blank">Descargar plantilla</a>
                    </div>
                </div>
            </Modal>
            <Modal modal={modalrubros} updateModal={setModalrubros} eventModal={importAdquisitionItemBudgetID}>
                <div className="row">
                    <div className="col-md-12">
                        <FileInput
                            Media={imp.bean.Media}
                            MediaContext={imp.bean.MediaContext}
                            directory='temp'
                            label='Archivo'
                            docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                            onCreate={(Filemap: any) => { imp.setBean({ ...imp.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-12">
                        <a href="assets/extra/Rubro.xlsx" className="link" target="_blank">Descargar plantilla</a>
                    </div>
                </div>
            </Modal>
            {/* Modal multiple para mostrar las configuraciones del plan  */}
            <Modal modal={modal1} updateModal={setModal1} eventModal={updateItemModal}>
                <>
                    {modal1.view &&
                        <>
                            {vista === 0 &&
                                <Alert clase="warning" key={'alert-generica'}>
                                    <strong>Sin elementos para mostrar</strong>
                                </Alert>
                            }
                            {vista === 1 &&
                                <AdquisitionPeople bean={bean} />
                            }
                            {/* si es boton modificar estados */}
                            {vista === 2 &&
                                <AdquisitionStates bean={bean} />
                            }
                            {vista === 3 &&
                                <AdquisitionPlanFunctionalID role={ITEM_ADMIN} bean={bean} />
                            }
                            {vista === 4 &&
                                <AdquisitionHistory bean={bean} />
                            }
                            {vista === 5 &&
                                <AdquisitionPhase bean={bean} handleUpdate={() => { setModal1({ ...modal1, "view": false }); getLista() }} />
                            }
                            {vista === 6 &&
                                // este componente muestra los items general para todo el plan de adquisiciones no tiene opcion de editar items 
                                <AdquisitionItemCatalog _phaseState={bean.PhaseState} key={bean[idBean]} idAdquisitionPlan={bean[idBean]} rol={1} />
                            }
                        </>
                    }
                </>

            </Modal>
            <Modalcompras modal={modal} updateModal={setModal} onSubmit={handleSubmit(updateItem)}>
                {/* crear editar items necesidades */}
                <div className="row">

                    {modal.view &&
                        <>
                            <div className="col-md-6">
                                <label >Año Inicial</label>
                                <input type="number" readOnly={validarEdit()} className="form-control" value={bean.Year} onChange={(e) => { setBean({ ...bean, ['Year']: parseInt(e.target.value) }) }} />
                            </div>

                            {/* <div className="col-md-6">
                                <label >Tipo Presupuesto</label>
                                <select disabled={validarEdit()} className="form-control mt-2" {...register('Selectprop', { required: true })} value={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e.target.value }) }}>
                                    <option value={0}>...</option>
                                    {listaType.map((item: any) => {
                                        return (
                                            <option value={item.DataBeanProperties.Value}>{item.DataBeanProperties.Property}</option>
                                        )
                                    })}
                                </select>
                                {errors.Selectprop?.type === 'required' && <div className="alert alert-warning shadow" role="alert"><strong> Porfavor rellene el campo </strong></div>}
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetType _disabled={validarEdit()} idSelector={bean.IDBudgetIDType} onChange={(e: any) => { setBean({ ...bean, ['IDBudgetIDType']: e }) }}></SelectBudgetType>
                            </div> */}

                            <div className="col-md-6">
                                <InputMoney _label="Valor Estimado" readonly={validarEdit()} _value={bean.TotalValue} onChange={(e: any) => { setBean({ ...bean, 'TotalValue': e }) }} />
                            </div>

                            <div className="col-md-12">
                                <label >Descripción</label>
                                <textarea readOnly={validarEdit()} className="form-control " {...register('Description', { required: true })} value={bean.Description} onChange={(e) => { setBean({ ...bean, ['Description']: e.target.value }) }}></textarea>
                                {errors.Description?.type === 'required' && <div className="alert alert-warning shadow" role="alert"><strong> Por favor rellene el campo </strong></div>}
                            </div>
                            {bean.IDAdquisitionPlan == null &&
                                <>
                                    <div className="col-md-6">
                                        <BasicSwitch label="Copiar de otro plan" estado={migrar} eventChange={(e) => { setMigrar(e) }} />
                                    </div>
                                    <div className="col-md-12">
                                        {migrar &&
                                            <div className="row">
                                                <div className="col-md-6">
                                                    {/* <SelectAdquisitionPlan idSelector={year} onChange={(e)=>{console.log(e)}} /> */}
                                                    <label>Plan de compras</label>
                                                    <select name="plan" id="idplan" className="form-select" value={idPlan} onChange={(e) => { setIDPlan(parseInt(e.target.value)) }}>
                                                        <option value={0}>...</option>
                                                        {lista.map((item: any, index: number) => {
                                                            return (
                                                                <option key={index} value={item.DataBeanProperties.IDAdquisitionPlan}>{item.DataBeanProperties.Year} - {item.DataBeanProperties.Description}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </>

                            }
                        </>
                    }
                </div>
            </Modalcompras>

        </>
    )
}